<template>
  <div class="slider-home" v-show="disciplinas && disciplinas.length > 0">
    <h2 class="float-left">Disciplinas</h2>

    <carousel :dots="true" ref="carouselDisciplinasHome">
      <carousel-item v-for="(disciplina, index) in disciplinas"
                     :key="'disciplina-' + disciplina.referencia + '-' + index"
                     :titulo="disciplina.disciplina"
                     :imagem="disciplina.imagem"
                     texto-url="ver disciplina"
                     :url="disciplina.url"
                     :disciplinaCarousel="true" />
    </carousel>
  </div>
</template>

<script>
import CarouselItem from '@/core/components/CarouselItem'
import Carousel from '@/core/components/Carousel'
import DisciplinaAPI from '@/api/disciplina-api'
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'DisciplinasCarousel',
  components: { Carousel, CarouselItem },

  data () {
    return {
      disciplinas: []
    }
  },

  mounted () {
    DisciplinaAPI.listarHome().then(data => {
      this.disciplinas = data.map(disciplina => {
        disciplina.url = `/disciplina/${disciplina.referencia}`
        disciplina.imagem = ImageUtils.obterUrlCompletaImagem(`${disciplina.imagem}`, 'disciplinas-app/')
        return disciplina
      })

      this.$refs.carouselDisciplinasHome.applyOwlCarousel()
    })
  }
}
</script>

<style scoped>

</style>
